import moment from "moment";
import VuetableFieldCheckbox from "@/plugins/vuetable-checkbox/VuetableFieldCheckboxLoadWarehouse";
import numeral from 'numeral'
import i18n from '@/plugins/i18n';
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import store from '@/store/main.js';
import Cookies from "js-cookie";

function formatNumber(value) {
    return numeral(value).format("0,0");
}

export default [
  {
    name: VuetableFieldCheckbox,
    title: "Checkbox",
    width: "10px",
    togglable: false,
    disabled: function(rowData){
      let limitWarehouse = ["free", "basic"].includes(JSON.parse(Cookies.get('plan')).series);
      if (!limitWarehouse) {
        if(rowData.disabled || rowData.is_default) return true;
        return false;
      } else {
        return true
      }
    },
  },
  {
    name: "warehouse_number",
    title: i18n.t('Warehouse No.'),
    width: "200px",
  },
  {
    name: "name",
    title: i18n.t('Warehouse Name'),
    width: "400px",

  },
  {
    name: "available_qty",
    title: i18n.t('_Inventory.Available QTY'),
    width: "100px",
    togglable: true,
    visible:true,
    formatter: value => {
      return '<span class=""><i class="fas fa-warehouse-alt mr-2"></i>' + formatNumber(value) + '</span>';
    }
  },
  {
    name: "status",
    title: i18n.t('Status'),
    width:'150px',
  },
  {
    name: "created_date",
    title: i18n.t('Created Date'),
    width: "150px",
    visible: true,
    togglable: true,
    formatter: (data) => {
      return convertTimezone.utcToLocal(data);
    }
  },
  {
    name: "created_by",
    togglable: true,
    visible:true,
    title: i18n.t('_Inventory.Created By'),
    width: "150px",
  },

];



// WEBPACK FOOTER //
// ./src/layouts/tenancy/admin/FieldsDef.js